import { existingTickets } from 'components/event';

export default function isTicketsExist(event) {
  const { maximum_tickets: tickets } = event;

  return _.isNil(tickets) || (tickets === 0) || existingTickets(event) > 0;
}
